import React from 'react';
import { Breadcrumbs, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { useState, useEffect } from 'react';
import { MultiselectItem } from '@cokitchen/cokitchen-components';
import { ROUTE_KEYS } from 'utils/constants';
import PageHeaderText from 'components/base/page-header-text';
import Select from 'components/base/select';
import StreakPauseReasonList from 'components/base/streak-pause-reason-list';
import { toast } from 'react-toastify';

interface StreakOption {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  multiplier_effect_percentage: number;
}
const PauseControl = () => {
  const breadCrumbs = [
    { name: 'Maintenance', path: ROUTE_KEYS.MAINTENANCE },
    {
      name: 'Pause Control',
      path: ''
    }
  ];

  const [streakValue, setStreakValue] = useState('');
  const [numberOfDays, setNumberOfDays] = useState(0);

  const [streakOptions, setStreakOptions] = useState<MultiselectItem[]>([]);
  const fetchStreakOptions = async () => {
    try {
      const response = await apiService.get(`loyalty-streak`, {
        isInternal: true
      });
      const options = response.data.map((option: StreakOption) => ({
        text: option.name,
        value: option.id,
        id: option.id
      }));
      setStreakOptions(options);
    } catch (err) {
      toast(<ToastMessage type='error' message='error fetching streak options' />);
    }
  };

  useEffect(() => {
    fetchStreakOptions();
    fetchStreakControl();
  }, []);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [keywords, setKeywords] = useState<string[]>(['Other']);

  const createMetadata = (keyword: string) => {
    setKeywords((prevKeywords) => [keyword, ...prevKeywords]);
  };

  const deleteMetadata = (keyword: string) => {
    if (keyword !== 'Other') {
      setKeywords((prevKeywords) => prevKeywords.filter((kw) => kw !== keyword));
    }
  };

  const fetchStreakControl = async () => {
    setLoading(true);
    try {
      const response = await apiService.get(`loyalty-streak-control`, {
        isInternal: true
      });

      setStreakValue(response.data[0]?.streak_pause_eligibility ?? '');
      setNumberOfDays(response.data[0]?.pause_days || '');
      setKeywords(response.data[0]?.reasons_for_pause || []);
    } catch (err) {
      toast(<ToastMessage type='error' message='Error fetching data' />);
    } finally {
      setLoading(false);
    }
  };

  const updateStreakControl = async () => {
    setLoading(true);

    try {
      const updatedData = {
        streak_pause_eligibility: streakValue,
        pause_days: numberOfDays,
        reasons_for_pause: keywords
      };

      await apiService.put(`internal/loyalty-streak-control/pause-control`, {
        data: updatedData,
        isInternal: true
      });
      toast(<ToastMessage type='success' message='Changes have been saved' />);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className=' md:ml-3 '>
        <Breadcrumbs breadcrumbs={breadCrumbs} />
        <div className=' max-w-[700px] h-auto pr-6 pl-1 pb-6 pt-3  items-center'>
          <PageHeaderText title='Pause Controls' description='Update pause control' />
          <div>
            <div className='relative'>
              <div>
                <p className='font-medium text-sm'>Streaks pause eligibility</p>
                <Select
                  value={streakValue}
                  options={streakOptions}
                  placeholder='1.1x'
                  onChange={(v) => {
                    setStreakValue(v);
                  }}
                />
              </div>

              <div className='mt-6'>
                <label htmlFor='number-of-pause-days' className='text-sm'>
                  Number of pause days
                </label>
                <div className='flex items-center h-[50px] border border-gray-2 rounded-md p-1 mt-2 mb-4'>
                  <input
                    readOnly
                    id='number-of-pause-days'
                    placeholder='14'
                    value={numberOfDays}
                    onChange={(e) => setNumberOfDays(Number(e.target.value))}
                    className='border border-white focus:outline-none w-[650px] h-[40px] px-4 py-2 rounded-md mt-2'
                  />
                  <span className='border rounded-md border-[#F2F2F3] p-1 bg-[#F2F2F3] text-xs mr-2 text-gray-6'>
                    QUARTER
                  </span>
                </div>
              </div>
            </div>

            <StreakPauseReasonList
              list={keywords}
              title='Reasons for pausing streaks'
              onCreate={(w) => createMetadata(w)}
              onDelete={(w) => deleteMetadata(w)}
            />

            <Button
              onClick={updateStreakControl}
              className='w-[180px] h-[30px] mt-10 ml-auto'
              variant='block'
              color='primary'
              loading={loading}>
              Update
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PauseControl;
